import script from "./JobInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./JobInfoModal.vue?vue&type=style&index=0&id=70bc2b34&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70bc2b34"]])

export default __exports__